/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Dropdown, Menu, Modal } from "antd";
import React, { useState, useEffect } from "react";
import { MoreOutlined, FileTextOutlined, ExclamationCircleOutlined, DeleteTwoTone, FileImageOutlined } from "@ant-design/icons";
import { FaRegFilePdf } from "react-icons/fa";
import { Loading } from "../../Common/components/Loading";
import CreateDocs from "../../PropertyComp/components/CreateDocs";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toolsAction } from "../state/actions";
import { EmptyData } from "../../Common/components/EmptyData";
import moment from "moment";
import { PropertyHandlers } from "../../PropertyComp/state/actions";
import { transactionLaneDataHandle } from "../../Rtd/state/actions";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { ERTSAction } from "../../ErtsModel/state/action";
import axios from "axios";
import ContractTypeBadge from "../../Common/components/ContractTypeBadge";
const OtherDocs = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [otherDocsState, setOtherDocsState] = useState({
    createDocsModalOpen: false,
  });
  const { otherDocsData, otherDocsLoading, triggerOtherDocsDataFetch } = useSelector((state) => state.ToolReducers.CommonToolsReducer);
  const { OtherDocsAccess, CoxFormsAccess, checkIsMarkEibnerBrokerageLoading } = useSelector((state) => state.ERTSReducer);
  let { uploadedPdfDocSuccess } = useSelector((state) => state.PropertyReducer, shallowEqual);
  const { getUserDetailsData } = useSelector((state) => state.account);

  let unmounted = {
    value: false,
  };
  let sourceAxios = axios.CancelToken.source();
  useEffect(() => {
    dispatch(ERTSAction.checkIsMarkEibnerBrokerage({ unmounted, sourceAxios }));
    return () => {
      unmounted.value = true;
      sourceAxios.cancel("Cancelling in cleanup");
    };
  }, []);

  useEffect(() => {
    dispatch(toolsAction.getOtherDocsData());
  }, [triggerOtherDocsDataFetch, uploadedPdfDocSuccess]);

  const handleDeletePropertyDocs = (ele) => {
    Modal.confirm({
      title: "Are you sure you want to delete this document?",
      content: "Note: This action is irreversible. Deleting this document will permanently remove it from your account.",
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined style={{ color: "orange" }} />,
      onOk() {
        const payloadData = {
          documentId: ele?.documentId,
          source: "OTHER_DOCS",
        };
        dispatch(PropertyHandlers.deletePropertyContractDocs({ payloadData }));
      },
      onCancel() {},
    });
  };
  const handleCreateDocCancel = () => {
    setOtherDocsState({
      createDocsModalOpen: false,
    });
  };
  const handleOpenDoc = (eachDoc = {}) => {
    if (typeof eachDoc !== "object") return;
    if (eachDoc.isPdf || eachDoc.pdfLink) {
      window.open(eachDoc.pdfLink, "_blank");
    } else if (eachDoc.fileType === "IMAGE" || eachDoc.fileType === "PDF") {
      if (eachDoc?.fileUrl) {
        window.open(eachDoc?.fileUrl);
      }
    } else {
      let buildData = {
        builtForSection: "DOCUMENT",
        documentId: eachDoc._id,
        builtForId: getUserDetailsData?._id,
        key: getUserDetailsData?._id,
        contractType: eachDoc.contractType,
        contractId: eachDoc.contractId,
        openFor: "BUYER_AGENT",
        token: localStorage.getItem("userAuth"),
        signable: true,
        ...(eachDoc.RTDInitiator && { RTDInitiator: eachDoc.RTDInitiator }),
      };
      dispatch(transactionLaneDataHandle.generateUrlIdAndRedirect({ buildData, currentPath: location?.pathname }));
    }
  };

  const MenuItem = (props = {}) => {
    return (
      <Menu onClick={(event) => event?.domEvent?.stopPropagation()}>
        <Menu.Item key="deleteDocument" onClick={() => handleDeletePropertyDocs(props.item)}>
          <DeleteTwoTone
            style={{
              fontSize: 16,
            }}
          />
          <span style={{ color: "04396B" }}> Delete document</span>
        </Menu.Item>
      </Menu>
    );
  };
  return (
    <div style={{ height: "calc(100vh - 8rem)", overflowY: "auto", overflowX: "hidden" }}>
      {otherDocsState?.createDocsModalOpen && (
        <Modal
          width={"700px"}
          onCancel={() => {
            setOtherDocsState({ ...otherDocsState, createDocsModalOpen: false });
          }}
          open={otherDocsState?.createDocsModalOpen}
          footer={false}
          title={<div className="commonModalTitle">Create Other Docs</div>}
        >
          <div
            style={{
              height: "65vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "-10px",
            }}
          >
            <CreateDocs role={"NON_TRANSACTION_DOCS"} handleCreateDocCancel={handleCreateDocCancel} />
          </div>
        </Modal>
      )}

      {checkIsMarkEibnerBrokerageLoading || otherDocsLoading ? (
        <Loading />
      ) : (
        <div style={{ padding: "20px 0" }}>
          <Button
            type="primary"
            onClick={() => {
              setOtherDocsState({ ...otherDocsState, createDocsModalOpen: true });
            }}
            disabled={!(OtherDocsAccess || CoxFormsAccess)}
            style={{ marginBottom: "20px" }}
          >
            Create Other Docs
          </Button>

          {otherDocsData?.length ? (
            <div
              style={{
                width: "100%",
                maxWidth: "800px",
                padding: "0 20px",
                overflow: "auto",
                borderRadius: "8px",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "15px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      borderBottom: "1px solid #ccc",
                      backgroundColor: "hsl(211deg 75% 48%)",
                      color: "white",
                    }}
                  >
                    <th style={{ textAlign: "center", padding: "10px" }}>File Name</th>
                    <th style={{ textAlign: "center", padding: "10px" }}>Creation Date</th>
                    <th style={{ textAlign: "center", padding: "10px" }}>Options</th>
                  </tr>
                </thead>
                <tbody>
                  {otherDocsData.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        borderBottom: "1px solid #eee",
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "white", // subtle striping
                      }}
                    >
                      <td
                        style={{
                          padding: "10px 5px 10px 30px",
                          verticalAlign: "middle",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleOpenDoc(item);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          {item.fileType === "IMAGE" ? (
                            <FileImageOutlined
                              style={{
                                color: "#ecd540",
                                marginTop: "5px",
                                marginRight: "5px",
                                fontSize: "18px",
                              }}
                            />
                          ) : item.fileType === "PDF" || item.isPdf || item.pdfLink ? (
                            <FaRegFilePdf
                              style={{
                                color: "red",
                                marginTop: "5px",
                                marginRight: "5px",
                                fontSize: "18px",
                              }}
                            />
                          ) : (
                            <FileTextOutlined style={{ color: "#74b3ed", fontSize: "18px" }} />
                          )}
                          <ContractTypeBadge contractType={item?.contractType} additionalStyle={{ fontSize: "12px" }} />
                          <span
                            style={{
                              color: "blue",
                              fontSize: "16px",
                              maxWidth: "270px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "inline-block",
                            }}
                          >
                            {item?.documentName}
                          </span>
                        </div>
                      </td>

                      <td style={{ textAlign: "center", padding: "10px" }}>
                        {item?.createdAt ? (
                          <div>
                            <div>{moment(item.createdAt).format("MM/DD/YYYY")}</div>
                            <div style={{ fontSize: "13px", color: "#777" }}>{moment(item.createdAt).format("hh:mm A")}</div>
                          </div>
                        ) : (
                          "--"
                        )}
                      </td>
                      <td style={{ textAlign: "center", padding: "10px" }}>
                        <Dropdown trigger={["click", "hover"]} overlay={<MenuItem item={item} />}>
                          <MoreOutlined
                            style={{
                              cursor: "pointer",
                              fontSize: "20px",
                              color: "#085190",
                            }}
                          />
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div style={{ marginTop: "200px" }}>
              <EmptyData />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OtherDocs;
